import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import * as PATHS from './config';
import Template from './template';
import About from './pages/about';
import Board from './pages/board';
import Collection from './pages/collection';
import View from './pages/view';
import Marketplace from './pages/marketplace';
import Page404 from './pages/404';
import Offers from './pages/offers';
import OfferWatcher from '../components/OfferWatcher';
import TokenHistory from './pages/tokenHistory';
import Home from './pages/home';

const Layout = () => (
    <>
        <OfferWatcher />
        <Router>
            <Template>
                <Routes>
                    <Route path='*' element={ <Page404 /> } />
                    <Route path={ PATHS.PATH_ABOUT } element={ <About /> } />
                    <Route path={ PATHS.PATH_BOARD } element={ <Board /> } />
                    <Route path={ PATHS.PATH_COLLECTION } element={ <Collection /> } />
                    <Route path={ PATHS.PATH_HISTORY } element={ <TokenHistory /> } />
                    <Route path={ PATHS.PATH_MARKETPLACE } element={ <Marketplace /> } />
                    <Route path={ PATHS.PATH_OFFERS } element={ <Offers /> } />
                    <Route path={ PATHS.PATH_VIEW } element={ <View /> } />
                    <Route index element={ <Home /> } />
                </Routes>
            </Template>
        </Router>
    </>
)

export default Layout